import Footer from "../Footer/Footer";
import Header from "../Header/Header";

const EmailSent = () => {
  return (
    <div>
      <Header
        title="Reset Your Password"
        desktopHeight="auto"
        textBackground="Reset Password"
        backgroundImg="http://res.cloudinary.com/brabenjos/image/upload/v1729584914/sodastream/1729584914532.png"
        subTitle=""
      />
    <section className="relative w-full mt-[-35%] z-50 mb-[0px] lg:mb-[190px] p-4">
        <div className="md:relative gap-10 z-50 flex flex-col items-center justify-center w-full">
          <div className="bg-white rounded-xl border-[0.5px] border-[#75A7AD] relative 
          sm:w-[50%] opacity-80 px-10 py-20 text-[#005D6E]">
            <div className="bg-white p-6 flex flex-col items-center mt-[-13%]">
              <h2 className="mt-4 text-2xl font-bold text-[#75A7AD]">
                Check your email!
              </h2>
              <p className="mt-2 text-lg text-gray-700 text-center">
                We've sent you an email with instructions to reset your password. 
                <br />
                Please follow the link in the email to create a new password and regain access to your SodaStream account.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer/>
    </div>
  );
};

export default EmailSent;

